import { getPath } from '@/router/common'

const baseUrl = {
  title: '质控管理',
  path: 'QualityManage'
}

export default [
  {
    path: getPath('ProblemShipment', baseUrl),
    name: 'ProblemShipment',
    component: () => import(/* webpackChunkName: "ProblemShipment" */ '@/views/qualityManage/problemShipment/index.vue'),
    meta: {
      title: '问题件管理'
    }
  },
  {
    path: getPath('AbnormalRegisterMerge', baseUrl),
    name: 'AbnormalRegisterMerge',
    component: () => import(/* webpackChunkName: "AbnormalRegisterMerge" */ '@/views/qualityManage/abnormalRegisterMerge/index.vue'),
    meta: {
      title: '异常登记'
    }
  },
  {
    path: getPath('ProblemAddOrModify', baseUrl),
    name: 'ProblemAddOrModify',
    component: () => import(/* webpackChunkName: "ProblemAddOrModify" */ '@/views/qualityManage/problemAddOrModify/index.vue'),
    meta: {
      title: '问题件上报'
    }
  },
  {
    path: getPath('NoHeaderfileShipment', baseUrl),
    name: 'NoHeaderfileShipment',
    component: () => import(/* webpackChunkName: "NoHeaderfileShipment" */ '@/views/qualityManage/noHeaderfileShipment/index.vue'),
    meta: {
      title: '无头件管理'
    }
  },
  {
    path: getPath('NoHeaderfileAddOrModify', baseUrl),
    name: 'NoHeaderfileAddOrModify',
    component: () => import(/* webpackChunkName: "NoHeaderfileAddOrModify" */ '@/views/qualityManage/noHeaderfileAddOrModify/index.vue'),
    meta: {
      title: '无头件上报'
    }
  },
  {
    path: getPath('AsterShipment', baseUrl),
    name: 'AsterShipment',
    component: () => import(/* webpackChunkName: "AsterShipment" */ '@/views/qualityManage/asterShipment/index.vue'),
    meta: {
      title: '弃货管理'
    }
  },
  {
    path: getPath('AsterAddOrModify', baseUrl),
    name: 'AsterAddOrModify',
    component: () => import(/* webpackChunkName: "AsterAddOrModify" */ '@/views/qualityManage/asterAddOrModify/index.vue'),
    meta: {
      title: '弃件上报'
    }
  },
  {
    path: getPath('RewardspenaltiesShipment', baseUrl),
    name: 'RewardspenaltiesShipment',
    component: () => import(/* webpackChunkName: "RewardspenaltiesShipment" */ '@/views/qualityManage/rewardspenaltiesShipment/index.vue'),
    meta: {
      title: '奖惩管理'
    }
  },
  {
    path: getPath('RewardspenaltiesReg', baseUrl),
    name: 'RewardspenaltiesReg',
    component: () => import(/* webpackChunkName: "RewardspenaltiesReg" */ '@/views/qualityManage/rewardspenaltiesReg/index.vue'),
    meta: {
      title: '奖惩登记'
    }
  }
]
